import React from 'react';
import HubspotForm from 'react-hubspot-form';
import classNames from 'classnames';
import { Skeleton } from 'antd';

export const AForm = ({
  formId,
  onSubmit,
  onReady,
  inline,
  dark,
  optText,
  showDefaultOptText,
}) => {
  return (
    <>
      <div
        className={classNames(
          'hubspot-form aform',
          '[&_::placeholder]:text-sm [&_::placeholder]:text-black/40 [&_::placeholder]:opacity-100 sm:[&_::placeholder]:text-base',
          '[&_form]:w-full',
          '[&_fieldset]:min-w-full',
          '[&_label]:mb-2 [&_label]:flex [&_label]:items-center [&_label]:text-sm [&_label]:leading-none [&_label]:text-black sm:[&_label]:text-base',
          '[&_select]:appearance-none [&_select]:bg-[url(https://cdn.runalloy.com/graphics/svg/icon-drop-down-suffix.svg)] [&_select]:bg-[right_10px_top_16px] [&_select]:bg-no-repeat',
          '[&_.form-columns-2]:flex [&_.form-columns-2]:gap-3',
          '[&_.input]:!mr-0',
          '[&_.hs-form-field]:mb-4',
          '[&_.hs-input]:h-12 [&_.hs-input]:!w-full [&_.hs-input]:rounded [&_.hs-input]:border [&_.hs-input]:border-black/10 [&_.hs-input]:px-3 [&_.hs-input]:text-sm [&_.hs-input]:outline-none [&_.hs-input]:transition-smooth hover:[&_.hs-input]:border-black/60 sm:[&_.hs-input]:text-base',
          '[&_.hs-input.error]:border-red-600 [&_.hs-input.invalid]:border-red-600',
          '[&_.hs-input.hs-fieldtype-textarea]:min-h-28 [&_.hs-input.hs-fieldtype-textarea]:py-3',
          '[&_.hs-submit]:mt-8 [&_.hs-submit]:w-max',
          '[&_.hs-button]:h-12 [&_.hs-button]:cursor-pointer [&_.hs-button]:!whitespace-nowrap [&_.hs-button]:rounded-full [&_.hs-button]:border [&_.hs-button]:border-black/10 [&_.hs-button]:bg-azure-800 [&_.hs-button]:px-6 [&_.hs-button]:text-sm [&_.hs-button]:font-medium [&_.hs-button]:text-white [&_.hs-button]:transition-smooth hover:[&_.hs-button]:bg-azure-900',
          '[&_.hs-form-required]:ml-1 [&_.hs-form-required]:text-red-600',
          '[&_.hs-error-msg]:mb-0 [&_.hs-error-msg]:text-red-600',
          '[&_.hs-field-desc]:mb-3 [&_.hs-field-desc]:text-xs [&_.hs-field-desc]:text-black/80',
          '[&_.hs-error-msgs]:mb-0 [&_.hs-error-msgs]:mt-2 [&_.hs-error-msgs]:list-none [&_.hs-error-msgs]:p-0',
          '[&_.submitted-message]:flex [&_.submitted-message]:gap-2',
          '[&_.submitted-message_p]:mb-0 [&_.submitted-message_p]:text-base [&_.submitted-message_p]:text-black/80 dark:[&_.submitted-message_p]:text-white/80',
          // 'before:[&_.submitted-message]:mt-1 before:[&_.submitted-message]:block before:[&_.submitted-message]:h-5 before:[&_.submitted-message]:w-5 before:[&_.submitted-message]:bg-[url(https://cdn.runalloy.com/graphics/svg/icon-check-green-bg.svg)] before:[&_.submitted-message]:bg-no-repeat',
          {
            'dark-mode dark': dark,
            '[&_.hs-button]:!h-10 [&_.hs-button]:!rounded [&_.hs-error-msgs]:hidden [&_.hs-form-field]:!mb-0 [&_.hs-form-field]:w-full [&_.hs-form]:flex [&_.hs-form]:flex-row [&_.hs-form]:justify-between [&_.hs-form]:gap-1.5 [&_.hs-form]:rounded [&_.hs-form]:border [&_.hs-form]:border-black/20 [&_.hs-form]:bg-transparent [&_.hs-form]:p-0.5 [&_.hs-form]:transition-smooth dark:[&_.hs-form]:border-white/10 dark:[&_.hs-form]:bg-white/20 [&_.hs-input]:!h-10 [&_.hs-input]:!border-transparent [&_.hs-input]:bg-transparent [&_.hs-input]:!text-sm dark:[&_.hs-input]:text-white [&_.hs-recaptcha]:hidden [&_.hs-submit]:!mt-0 [&_.submitted-message]:rounded [&_.submitted-message]:border [&_.submitted-message]:border-black/10 [&_.submitted-message]:px-3 [&_.submitted-message]:py-[11px] [&_.submitted-message]:!text-sm dark:[&_.submitted-message]:border-0 [&_::placeholder]:!text-sm dark:[&_::placeholder]:text-white/50 [&_label]:hidden':
              inline,
          }
        )}
      >
        <HubspotForm
          portalId="6359009" // Alloy portal id. Do not change.
          formId={formId}
          onSubmit={onSubmit}
          onReady={onReady}
          loading={
            inline ? (
              <Skeleton.Input loading active />
            ) : (
              <Skeleton loading active />
            )
          }
        />
      </div>
      {(optText || showDefaultOptText) && (
        <div className="mt-6 text-xs tracking-[0.2px] text-black/60 dark:text-white/80">
          {optText ? (
            optText
          ) : (
            <>
              **By entering your information and submitting this form, you
              consent to receive marketing communications (such as newsletters,
              blog posts, webinars, event invitations and new product updates),
              and targeted advertising from Alloy (and any other company
              involved in this particular campaign) from time to time. You can
              unsubscribe from marketing emails at any time by clicking on the
              “Unsubscribe” link at the bottom of emails.
            </>
          )}
        </div>
      )}
    </>
  );
};
